import { render, staticRenderFns } from "./KanriRedirectPage.vue?vue&type=template&id=ac78f418&scoped=true&"
import script from "./KanriRedirectPage.vue?vue&type=script&lang=ts&"
export * from "./KanriRedirectPage.vue?vue&type=script&lang=ts&"
import style0 from "./KanriRedirectPage.vue?vue&type=style&index=0&id=ac78f418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac78f418",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VCardTitle,VProgressCircular})
